var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22922 13.2127C3.52561 13.2112 1.01005 11.0008 0.633826 7.97622C0.382636 5.95726 1.05028 4.24515 2.5236 2.84836C2.91668 2.47567 3.41502 2.4708 3.73945 2.81384C4.07696 3.17071 4.02135 3.64662 3.61329 4.04315C2.39193 5.23014 1.91981 6.66245 2.34429 8.3194C2.7682 9.97414 3.85763 11.0305 5.50611 11.4644C8.00521 12.1222 10.5814 10.3278 10.8522 7.77587C11.0097 6.29206 10.5308 5.0497 9.45823 4.02897C9.20653 3.78945 9.10731 3.50973 9.18746 3.18073C9.26098 2.8791 9.46999 2.69028 9.7709 2.6102C10.066 2.53161 10.3178 2.62316 10.5361 2.82143C11.581 3.77038 12.2252 4.94605 12.4379 6.33618C12.8625 9.11078 11.3344 11.7569 8.73255 12.7987C8.02793 13.0808 7.29502 13.2198 6.22922 13.2127Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34798 2.95129C7.34798 3.64832 7.34941 4.34536 7.34748 5.04246C7.34612 5.55884 7.01145 5.91097 6.53197 5.9061C6.0665 5.90138 5.73996 5.55039 5.73937 5.04661C5.73789 3.65248 5.73795 2.25834 5.73937 0.864272C5.73989 0.34818 6.07589 -0.0050308 6.55466 5.41953e-05C7.01955 0.00506862 7.34598 0.356629 7.34748 0.860118C7.34948 1.55715 7.34798 2.25419 7.34798 2.95129Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/signOut.5a48353229b33e1b9461499df5d950ad.svg";
export { ForwardRef as ReactComponent };